import React from 'react';

function PublicationItem({ venue, title }) {
    return (
        <div className="publication-item group relative pl-4 border-l-2 border-slate-200 dark:border-slate-800 hover:border-primary transition-colors py-2">
            <p className="text-sm text-slate-500 mb-1">{venue}</p>
            <h4 className="text-md font-semibold group-hover:text-primary dark:group-hover:text-sky-300 transition-colors">
                {title}
            </h4>
        </div>
    );
}

export default PublicationItem;
